import React, { RefObject } from "react"
import { TourStep } from "../TourDocument"

export interface InventoryVedFormTourRefs {
    requiredFields: RefObject<HTMLDivElement>
    optionalFields: RefObject<HTMLDivElement>
    requiredScanKiz: RefObject<HTMLDivElement>
    comment: RefObject<HTMLDivElement>
    goodsSelection: RefObject<HTMLDivElement>
    lotSelection: RefObject<HTMLDivElement>
    lotSearchOptions: RefObject<HTMLDivElement>
    selectionSettings: RefObject<HTMLDivElement>
    itemsGrid: RefObject<HTMLDivElement>
    itemCommands: RefObject<HTMLDivElement>
    gridSearch: RefObject<HTMLDivElement>
    totalsAccordion: RefObject<HTMLDivElement>
    additionalActions: RefObject<HTMLDivElement>
}

export const getInventoryVedFormTourSteps = (refs: InventoryVedFormTourRefs): TourStep[] => [
    {
        target: () => refs.requiredFields.current,
        description: "Для создания инвентаризационной ведомости заполняем обязательные поля",
        placement: "bottom",
    },
    {
        target: () => refs.optionalFields.current,
        description: 'Поля "Пользователь" и "Место хранения" заполняем при необходимости',
        placement: "bottom",
    },
    {
        target: () => refs.requiredScanKiz.current,
        description: 'Если "Обязательное сканирование КИЗ" включено, то в этой ведомости необходимо сканировать все КИЗы добавленных партий. Если отключено, то сканировать КИЗы нужно лишь для партий с недостачей',
        placement: "bottom",
    },
    {
        target: () => refs.comment.current,
        description: "Здесь можно оставить комментарий к ведомости",
        placement: "top",
    },
    {
        target: () => refs.lotSelection.current ?? refs.goodsSelection.current,
        description: "Подбор позиций в ведомость осуществляется через строку подбора",
        placement: "top",
    },
    {
        target: () => refs.lotSearchOptions.current,
        description: (
            <div>
                Подбирать товар можно следующим данным:
                <ul>
                    <li>Сканирование КИЗ/Короба</li>
                    <li>Сканирование штрих-кода</li>
                    <li>Ввод наименования товара</li>
                    <li>Ввод кода товара</li>
                    <li>Ввод GTIN SGTIN</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.selectionSettings.current,
        description: (
            <div>
                Дополнительные настройки подбора товаров:
                <ul>
                    <li>"Подбирать из ТО" - если активно, то подбираются существующие партии из товарных остатков. Если неактивно - то подбирается товар из номенклатуры и создаётся новая партия.</li>
                    <li>"Только остатки" - если активно, то осуществляется поиск только партий с остатком больше 0. Если неактивно, то по всем партиям, даже израсходованным.</li>
                    <li>"Только КИЗ" - если активно, то осуществляется поиск только по маркированным партиям. Если неактивно, то по всем партиям.</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.itemsGrid.current,
        description: 'В этой таблице отображаются все добавленные в ведомость позиции. Колонка "Количество" может быть изменена без открытия на редактирование.',
        placement: "top",
    },
    {
        target: () => refs.itemCommands.current,
        description: (
            <div>
                Кнопки управления позициями документа:
                <ul>
                    <li>"Сканировать КИЗ" - позволяет смотреть и редактировать отсканированные КИЗ партии</li>
                    <li>"Редактировать запись" - открывает выделенную позицию на редактирование.</li>
                    <li>"Удалить запись" - удаляет выделенную запись из документа</li>
                    <li>"Удалить строки из документа" - очищает весь документ, удаляя все позиции.</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.gridSearch.current,
        description: "Данный поиск ищет позицию в текущем документе, поиск только по наименованию",
        placement: "bottom",
    },
    {
        target: () => refs.totalsAccordion.current,
        description: "При развёрнутом аккордеоне отображается информация о суммах документа",
        placement: "top",
    },
    {
        target: () => refs.additionalActions.current,
        description: (
            <div>
                Дополнительные действия при работе с ведомостью:
                <ul>
                    <li>"Получить остатки" - заполняет документ ненулевыми остатками выбранного склада</li>
                    <li>"Получить остатки, только маркированный товар" - заполняет документ ненулевыми маркированными остатками выбранного склада</li>
                    <li>"Заполнить факт. кол-во документальным кол-вом" - указывает фактическое количество для всех позиций документа, равное документальному.</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
]
